/**
 * Handoff from RYD Admin → AI Tutor curriculum editor.
 * Same encoding as teacher upload handoff, with role/admin fields for edit mode.
 *
 * Payload (query `code`) is URL-safe base64 (no padding) of JSON:
 * {
 *   token: "<admin bearer>",
 *   name: "<display name>",
 *   role: "admin",
 *   slug?: "<course slug>",
 *   curriculumId?: number
 * }
 */

const DEFAULT_AI_ORIGIN = "https://ai.rydlearning.com";
const DEFAULT_CURRICULUM_EDIT_PATH = "/curriculum-edit";

export function encodeAdminCurriculumHandoffSegment(authUser, options = {}) {
  const token =
    (authUser && authUser.token) ||
    (typeof localStorage !== "undefined" ? localStorage.getItem("token") : null);
  if (!token || typeof token !== "string") {
    throw new Error("Admin session token is required for curriculum handoff");
  }

  const name =
    [authUser?.firstName, authUser?.lastName].filter(Boolean).join(" ").trim() ||
    authUser?.displayName ||
    authUser?.fullName ||
    authUser?.name ||
    "Admin";

  const payload = {
    token,
    name,
    role: "admin",
  };

  const slug = options.slug != null ? String(options.slug).trim() : "";
  if (slug) payload.slug = slug;

  if (options.curriculumId != null && Number.isFinite(Number(options.curriculumId))) {
    payload.curriculumId = Number(options.curriculumId);
  }

  const json = JSON.stringify(payload);
  return btoa(unescape(encodeURIComponent(json)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

export function buildAiTutorCurriculumEditUrl(authUser, options = {}) {
  const code = encodeAdminCurriculumHandoffSegment(authUser, options);
  const origin = (
    process.env.REACT_APP_AI_TUTOR_ORIGIN ||
    process.env.REACT_APP_AI_CURRICULUM_PREVIEW_ORIGIN ||
    DEFAULT_AI_ORIGIN
  ).replace(/\/+$/, "");
  const path = (
    process.env.REACT_APP_AI_TUTOR_CURRICULUM_EDIT_PATH ||
    DEFAULT_CURRICULUM_EDIT_PATH
  ).replace(/\/+$/, "");
  const q = new URLSearchParams({ code });
  return `${origin}${path}?${q.toString()}`;
}
